

exports.__esModule = true;
exports.$MiniBrowser = void 0;
var _angular = require("angular");
var _index = require("xo-return-to-merchant/dist/index");
var _integration = require("./integration");
var _squid = require("squid");
var _logger = require("xo-beaver/dist/logger");
var MiniBrowser = _squid.$Class.extend('MiniBrowser', {
  isMiniBrowser: false,
  partnerIntegration: false,
  isDirectIntegration: false,
  _isMiniBrowser: function _isMiniBrowser() {
    return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
  },
  _isFrame: function _isFrame() {
    return _squid.$util.isIFrame();
  },
  initialize: function initialize(cancel_url) {
    this.isMiniBrowser = _angular.$rootScope.miniBrowser = this._isMiniBrowser();
    this.isFrame = this._isFrame();
    this.partnerIntegration = _angular.$rootScope.partnerIntegration = _angular.$window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1';

    //  this.nativeIntegration is true, whenever the query param native_xo=1 when hermes was launched
    this.nativeIntegration = _squid.$util.param('native_xo') === '1';
    this.isDirectIntegration = this.isMiniBrowser || this.partnerIntegration || Boolean(_squid.$util.param('incontext')) || _angular.$window.location.pathname.indexOf('/checkoutnow') > -1;
    _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
    if (this.partnerIntegration) {
      _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
      _logger.$logger.info('partner_integration_flow');
    } else if (this.nativeIntegration && (0, _squid.$feature)('nativexoSupport')) {
      // we are setting the flow to be native checkout type
      // whenever the nativeIntegration flag is on
      // setting this flow will enable the redirect_uri query param
      // passed to hermes to override the merchant's redirect url
      // on cancel or redirect after a successful payment
      _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
      _logger.$logger.info('nativexo_integration_flow');
    }
    if (this.isMiniBrowser && !this.partnerIntegration) {
      var msg;
      try {
        msg = {
          cancelUrl: cancel_url,
          landingUrl: _angular.$window.location.href,
          secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
        };
      } catch (error) {
        return _logger.$logger.error('minibrowser_msg_construction_failed', {
          error: error
        });
      }
      if (!_index.$ReturnToMerchant.postToMerchant(msg)) {
        _logger.$logger.error('minibrowser_post_failed');
      }
    }
  }
});
var $MiniBrowser = exports.$MiniBrowser = new MiniBrowser();
angular.value("$MiniBrowser", $MiniBrowser);
_angular.$rootScope;
_angular.$window;
_index.$ReturnToMerchant;
_integration.$integration;
_integration.$FLOWS;
_squid.$Class;
_squid.$feature;
_squid.$locale;
_squid.$util;
_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./js/lib/miniBrowser.js
// module id = ./js/lib/miniBrowser.js
// module chunks = 0